import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { Helmet } from 'react-helmet'
import { Browser } from '../../services/helpers/Browser'
import { getSeoSettings } from '../../actions/seo/SeoSettingsAction'
import { getSeoSchema } from '../../actions/seo/SeoSchemaAction'
import { LicenseTypes } from '../footer/License'
import { LanguageService } from '../../services/LanguageService'
import Constants from '../../constants/Constants'
import SeoHelper from './SeoHelper'
import SeoSchemaHelper from '../../services/helpers/SeoSchemaHelper'
import Utils from '../../services/Utils'
import { LocalStorageService } from '../../services/LocalStorageService'
import { COLOR_MODE_KEY } from '../../constants/Enums/UiEnum'
/** 
 * HtmlHeadTags Component for inserting  tags to html head 
 * for example meta, link ,title
 * 
 */

//Temporary
const SEOExcludedPages = {
  'payment-submit': true,
  'playforreal': true,
  'popup': true,
  'global-bet': true
  // 'promotions':true
}
export const HandlePageName = (pageName, location) => {
  const urlParams = location.pathname.split('/')
  switch (pageName) {
    case 'pages':
    case 'games':
      return urlParams[3];
    case 'regulations':
      return 'rules';
    case 'sport':
      switch (urlParams[3] && urlParams[3].toLowerCase()) {
        case 'overview':
        case 'results':
          return urlParams[3];
        default:
          return 'sport';
      }
    case undefined:
    case '':
    case 'popup':
      return 'main';
    case 'tournaments':
    case 'tournament':
      return 'game-tournaments';
    case 'rules':
      return urlParams[4] || urlParams[3] || 'rules';
    case 'promotions':
      const promotionItem = urlParams[6];
      const categoryItem = urlParams[3];
      return promotionItem ? 'promotion' + promotionItem : (categoryItem ? 'promotionCategory' + categoryItem : 'promotions')
    case 'promotiondetails':
      return 'promotion' + urlParams[3]
    default:
      return pageName;

  }
}

class HtmlHeadTags extends React.Component {
    componentDidMount() {
    this.props.isSettingsLoading === false && this.onRouteChanged();
  }

  componentDidUpdate(prevProps) {
    if ((this.props.isSettingsLoading === false && this.props.location.pathname !== prevProps.location.pathname) || (this.props.isSettingsLoading !== prevProps.isSettingsLoading)) {
      this.onRouteChanged()
    }
  }

  getPagePrefix = (pageName) => {
    switch (pageName) {
      case 'games':
      // case 'rules':
      case 'pages':
        return `/${pageName}/`;
      case 'sport':
        const urlParams = this.props.location.pathname.split('/')
        switch (urlParams[3] && urlParams[3].toLowerCase()) {
          case 'overview':
          case 'results':
            return `/${pageName}/`;
          default:
            return '/';
        }
      // case 'regulations':
      //   return `/rules/`;
      case 'promotiondetails':
      case 'promotions':
      case 'rules':
        return '';
      default:
        return '/';

    }
  }
  onRouteChanged() {
    const { schema, seoSettings, location ,seoRulesEnabled} = this.props
    const urlParams = location.pathname.split('/')
    const isRules = false;
    const lang = urlParams[1];
   
   if(!seoRulesEnabled){
    // TEPRORARY SOLUTION (spetial for game info case);
    const urlPageParam = urlParams[2] === Constants.GAME_INFO ? urlParams[3] : urlParams[2]

    const pageName = HandlePageName(urlPageParam, this.props.location)
    const prefix = this.getPagePrefix(urlParams[2]);
    const now = new Date();
    const nowTimeStamp = now.getTime();
    const isSeoSettingCached = seoSettings && seoSettings[lang] && seoSettings[lang].hasOwnProperty(pageName) && (nowTimeStamp - seoSettings[lang][pageName].lastUpdated < seoSettings.cachingTime)
   
    //if data is not cached retrive it from the server 
        if (!isSeoSettingCached && !SEOExcludedPages[pageName] && (prefix || (seoRulesEnabled && pageName.startsWith('promotion')))) {
            this.props.dispatch(getSeoSettings({ languageId: lang, alias: pageName, prefix:prefix || '/' }, isRules))
          }
  }
    //Detect user agent string
    const userAgentString = Browser.getUserAgentString();
    const isSeoSchemaCached = schema && schema.hasOwnProperty(lang)
    //Do call to the server if seo bot crawling our website
    if (Browser.isCrawelerBot(userAgentString) && !isSeoSchemaCached) {
      this.props.dispatch(getSeoSchema(lang))
    }
  }

  getTextWithParams(text) {
    let { seoSettings } = this.props
    const seoParams = seoSettings[LanguageService.getSelectedLanguage()]?.params || {};
    return SeoHelper.supplant(text, seoParams);
  }

  getSiteScripts(lang, pageName) {
    const { schema, seoSettings, licenses={} } = this.props
    const siteScripts = []
    let seoSchemaData = schema[lang] != null ? schema[lang] : schema.default
    seoSchemaData = SeoSchemaHelper.processSchemaData(seoSchemaData);
    const seoParams = seoSettings[lang]?.params || {};
    // NEW: If sport event specific data exists, generate a dynamic SportsEvent schema.
    // This enables support for dynamic sport pages with custom schemas.

    if (pageName.startsWith('sport')) {
      seoSchemaData = SeoSchemaHelper.generateSportsEventSchema(seoParams, [JSON.parse(seoSchemaData)], lang);
    }

    siteScripts.push({ "type": "application/ld+json", innerHTML: seoSchemaData });

    if (Object.keys(licenses).length) {

      Object.keys(licenses).forEach((key) => {
        if (!LicenseTypes.noScript.includes(licenses[key].body)) {
          const sealId = licenses[key].sealId;
          const scriptPostfix = LicenseTypes[licenses[key].name][licenses[key].body].scriptPostfix;
          const src = `https://${sealId}.${scriptPostfix}`;

          siteScripts.push({
            "type": "text/javascript", innerHTML: LicenseTypes.scriptInsertMethod(src)
          })
        }
      })

    }
    return siteScripts;
  }

   applyColorModeChange = () => {
    const uiSettingMode = this.props.uiSettingMode;
        const storageData = LocalStorageService.get(COLOR_MODE_KEY);
        let settingMode = +(storageData?.mode ? storageData.mode : uiSettingMode);
  
        if (settingMode) {
          const colorMode = settingMode === 2 ? 'light' : settingMode === 1 ? 'dark' : null;
          
          if (colorMode) {
           // document.documentElement.dataset.theme = colorMode;
           return { 'data-theme': colorMode };
          }
          return {};
        }
      }

  render() {
    let { seoSettings, location, licenses, languages,seoRules,seoRulesEnabled } = this.props
    languages = languages || []
    licenses = licenses || []
    const urlParams = location.pathname.split('/')
    const lang = urlParams[1]
    let seoSettingsData = {}
    const pageName = HandlePageName(urlParams[2], this.props.location);
    /** NEW SEO LOGIC */
    if(seoRulesEnabled){
      const pathname = window.location.pathname;
      const {ids:blockIds} = seoRules.matchPaths[pathname] || {};
      const key = blockIds ? JSON.stringify(blockIds) : null;
      const seoContentData = seoRules.content[key] || {};
      seoSettingsData = seoContentData.meta || {}
    }else{
      seoSettingsData = (seoSettings[lang] != null && seoSettings[lang][pageName] && seoSettings[lang][pageName].data) ? seoSettings[lang][pageName].data : seoSettings.default
    }


    let matchLang = new RegExp(`\/${lang}(\/|$)?`)
    const laguagesLinks = languages.map((l) => {
      return {
        key: l.id,
        rel: "alternate",
        href: SeoHelper.addTrailingSlash(window.location.href.replace(location.pathname, location.pathname.replace(matchLang, `/${l.id}/`)), location.search),
        hreflang: LanguageService.getMomentLanguage(l.id)
      }
    })

    //Adding keyword and description meta tag
    const metaTags = [];

    if (seoSettingsData.keywords) {
      metaTags.push(
        { name: 'keywords', content: seoSettingsData.keywords }
      );
    }

    if (seoSettingsData.description) {
      metaTags.push(
        { name: 'description', content: this.getTextWithParams(seoSettingsData.description) }
      );
    }

    //Adding default language meta tag
    const defaultLang = languages.find((item) => (item.isDefault)) || {}
    if (defaultLang.id) {
      metaTags.push({ name: "language", content: defaultLang.id })
    }

    //Chenging canonical url if it is  default language |BLD-20523
    // (window.location.href.endsWith(`/${defaultLang.id}`) || window.location.href.endsWith(`/${defaultLang.id}/`))
    // ? window.location.href.replace(`/${defaultLang.id}`, '') 
    // : window.location.href;
    const siteScripts = this.getSiteScripts(lang, pageName);
    const htmlAttributes = { lang ,...this.applyColorModeChange()};
    const hrefLangUrl = window.location.href.replace(location.pathname, location.pathname.replace(matchLang, `/${defaultLang.id}/`));
 
    return (
      <Helmet
        htmlAttributes={htmlAttributes}
        encodeSpecialCharacters={true}
        title={this.getTextWithParams(seoSettingsData.title) || window.location.hostname}
        meta={[...metaTags]}
        link={
          [
            ...laguagesLinks,
            {
              rel: 'canonical',
              href: SeoHelper.addTrailingSlash(window.location.href, location.search)
            },
            {
              rel: 'alternate',
              href: SeoHelper.addTrailingSlash(hrefLangUrl, location.search),
              hreflang: 'x-default'
            }
          ]}
        script={[...siteScripts]}
      />
    )
  }
}

const mapStateToProps = (state) => {
  return ({
    isSettingsLoading: state.settings.isLoading,
    seoRulesEnabled: state.settings.seoRulesEnabled,
    languages: state.settings.languages,
    schema: state.seo.schema,
    seoSettings: state.seo.general,
    seoRules: state.seo.rules,
    licenses: state.settings.licenses,
    uiSettingMode: state.settings.uiSettingMode,
  })
}

const mapDispatchToProps = (dispatch, props) => {
  return ({
    dispatch,
    props
  })
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(HtmlHeadTags));

